import { TasksTypes, TasksAction, Task } from '../types';

export function getListTasks(tasks: Task[]): TasksAction<{ tasks: Task[] }> {
    return {
        type: TasksTypes.GET_LIST_TASKS,
        payload: { tasks },
    };
}

export function requestGetListTasks(ids: string[]): TasksAction<{ ids: string[] }> {
    return {
        type: TasksTypes.REQUEST_GET_LIST_TASKS,
        payload: { ids },
    };
}
export function saveTasks(tasks?: Task[]): TasksAction<{ tasks?: Task[] }> {
    return {
        type: TasksTypes.SAVE_TASKS,
        payload: { tasks },
    };
}

export function requestSaveTasks(tasks: Task[]): TasksAction<{ tasks: Task[] }> {
    return {
        type: TasksTypes.REQUEST_SAVE_TASKS,
        payload: { tasks },
    };
}

export function deleteTask(id?: string): TasksAction<{ id?: string }> {
    return {
        type: TasksTypes.DELETE_TASK,
        payload: { id },
    };
}

export function requestDeleteTask(id: string): TasksAction<{ id: string }> {
    return {
        type: TasksTypes.REQUEST_DELETE_TASK,
        payload: { id },
    };
}

export function deleteTasks(ids?: string[]): TasksAction<{ ids?: string[] }> {
    return {
        type: TasksTypes.DELETE_TASKS,
        payload: { ids },
    };
}

export function requestDeleteTasks(ids: string[]): TasksAction<{ ids: string[] }> {
    return {
        type: TasksTypes.REQUEST_DELETE_TASKS,
        payload: { ids },
    };
}
